export default "__VITE_ASSET__v6hb4aDW__"